import React from "react";
import { Modal } from "@shopify/polaris";
import DOMPurify from "dompurify";

function ArticleModal({ open, onClose, article }) {
  if (!article) return null;

  // Custom styles for modal content, inspired by typical Polaris and .view-article styling
  const modalContentStyles = `
    .Polaris-Modal-Dialog__Modal {
      max-width: 65% !important;
    }
    .article-modal-content {
      line-height: 1.5;
      font-size: 14px;
      color: #2c2c2c;
    }
    .article-modal-content h1{
      font-size: 28px;
      font-weight: 700;
      margin: 0 0 15px 0;
    }
    .article-modal-content h2 {
      font-weight: 700;
      font-size: 1.45em;
      border-radius: 4px;
      margin-bottom: 12px
    }
    .article-modal-content h3 {
      font-weight: 600;
      font-size: 1.25em;
      margin: 0 0 12px 0;
    }
    .article-modal-content p {
      margin: 0 0 15px 0;
    }
    .article-modal-content ul {
      margin: 0px 0 0px 15px;
      padding-left: 20px;
      list-style-type: disc;
    }
    .article-modal-content li {
      margin-bottom: 8px;
    }
    .article-modal-content strong {
      font-weight: 700;
    }
    .article-modal-content em {
      font-style: italic;
    }
    .article-modal-content br.newline-block {
      display: block;
      margin-bottom: 12px;
    }
    .Polaris-Modal-Header__Title {
      font-size: 17px !important;
    }
      .article-modal-content u,
.article-modal-content .underline {
  text-decoration: underline;
}
.article-modal-content s,
.article-modal-content strike,
.article-modal-content .strikethrough {
  text-decoration: line-through;
}
.article-modal-content mark {
  background-color: #ffe066;
}
.article-modal-content span[style] {
  /* Allow span styles through */
}

/* Optionally, generalize for color/highlight */
.article-modal-content span[style*="color:"] {
  /* no-op, but ensures class is not overridden */
}
.article-modal-content span[style*="background-color:"] {
  /* no-op */
}

  `;

  // Sanitize the article body, allowing the same tags and attributes as in .view-article
  let sanitizedContent = DOMPurify.sanitize(article.article_body, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "ul", "li", "a", "h1", "h2", "h3",
      "span", "img", "div", "table", "u", "s", "strike", "mark", "button", 'option', 'select', 'input', 'script'],
    ALLOWED_ATTR: [
      "href", "src", "alt", "width", "height", "style", "data-contrast", "class", "contenteditable", "target", "rel"
    ]
  });

  if (sanitizedContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(sanitizedContent, "text/html");
    const anchorTags = doc.querySelectorAll('a');
    anchorTags.forEach((anchor) => {
      anchor.setAttribute('target', '_blank');
    });
    
    sanitizedContent = doc.body.innerHTML;
  }


  // Replace \n\n\n\n with <br class="newline-block"> for consistency with generated content
  const formattedContent = sanitizedContent.replace(/\n\n\n\n/g, '<br class="newline-block">');

  return (
     <Modal
       open={open}
       onClose={onClose}
       title={article?.article_title || 'Article Preview'}
       primaryAction={{
         content: 'Close',
         onAction: onClose,
       }}
     >
       <style>{modalContentStyles}</style>
       <Modal.Section>
         <div
           className="article-modal-content"
           dangerouslySetInnerHTML={{
             __html: formattedContent || 'No content available.',
           }}
         />
       </Modal.Section>
     </Modal>
   );
}

export default ArticleModal;